import { useState } from "react";
import { Select } from "@/components/kit";
import { Icon } from "@/lib/icons";

// Per-screen sort choice remembered for the signed-in session (sessionStorage).
export function useSort(screen, defField, defDir) {
  const [sort, setSort] = useState(() => {
    try { const s = JSON.parse(sessionStorage.getItem(`rca_sort_${screen}`) || "null"); if (s && s.field) return s; } catch { /* ignore */ }
    return { field: defField, dir: defDir };
  });
  const update = (field, dir) => {
    const v = { field, dir };
    setSort(v);
    try { sessionStorage.setItem(`rca_sort_${screen}`, JSON.stringify(v)); } catch { /* ignore */ }
  };
  return [sort, update];
}

// One "Sort by" dropdown + a compact Ascending/Descending toggle. Fits a phone
// without horizontal scroll (labels collapse on small screens).
export function SortControl({ options, field, dir, onChange, testid = "sort" }) {
  return (
    <div className="flex items-center gap-1.5 shrink-0 min-w-0" data-testid={`${testid}-control`}>
      <span className="text-[13px] text-ink/55 hidden sm:inline">Sort by</span>
      <Select data-testid={`${testid}-field`} value={field} onChange={(e) => onChange(e.target.value, dir)}
        className="bg-warm-cream border border-ink/15 rounded-lg px-2.5 py-2 min-h-[42px] text-[14px]">
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </Select>
      <button type="button" data-testid={`${testid}-dir`} onClick={() => onChange(field, dir === "asc" ? "desc" : "asc")}
        title={dir === "asc" ? "Ascending" : "Descending"} aria-label={dir === "asc" ? "Ascending" : "Descending"}
        className="inline-flex items-center gap-1 border border-ink/15 bg-warm-cream rounded-lg px-2.5 min-h-[42px] text-[13px] font-semibold text-ink/70 hover:border-maroon/40 shrink-0">
        <Icon name="ChevronDown" className={`w-4 h-4 transition-transform ${dir === "asc" ? "rotate-180" : ""}`} />
        <span className="hidden sm:inline">{dir === "asc" ? "Asc" : "Desc"}</span>
      </button>
    </div>
  );
}
